// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `light-image .image-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  aspect-ratio: 16/9;
  background: var(--motes-black);
  box-sizing: border-box;
  z-index: 0;
}
light-image .image img {
  opacity: 0;
}
light-image .image img, light-image .thumb {
  position: absolute;
  opacity: 1;
  top: 0;
  left: 0;
  width: 100%;
  transform: scale(1.3);
  box-sizing: border-box;
}
light-image .thumb {
  overflow: hidden;
  z-index: 3;
  width: calc(100% + 20px);
  height: calc(100% + 20px);
  margin-top: -10px;
  margin-left: -10px;
}
light-image .thumb img {
  box-shadow: inset 0 0 2000px rgba(255, 255, 255, 0.5);
  filter: blur(10px);
  width: 100%;
  height: 100%;
}
light-image .thumb-hidden {
  will-change: auto;
  transform: scale(1.6);
  opacity: 0;
  transition: 1s;
  transition-delay: 100ms;
}
light-image .image-shown img {
  opacity: 1;
  transform: scale(1);
  transition: 0.7s ease-out;
  transition-delay: 100ms;
}
light-image .show-delayed {
  opacity: 0;
  animation: delayedFadeIn 2s ease-in 2s;
  animation-fill-mode: forwards;
}
@keyframes delayedFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
light-image .placeholder {
  background: var(--upload-background-gradient);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  opacity: 0;
  filter: blur(6px);
}
light-image .placeholder.show {
  opacity: 1;
  filter: blur(0);
  transition: 0.3s;
}
light-image .placeholder img {
  object-fit: contain;
  width: initial;
  height: 50%;
}
light-image .overlay {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  color: var(--motes-white);
  padding: var(--motes-padding);
  box-sizing: border-box;
  font-family: var(--header-font);
}
light-image .overlay .index {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  border: 2px solid var(--motes-white);
  border-radius: 100%;
  width: 43px;
  height: 43px;
  font-size: 20px;
  bottom: 10px;
  background-color: var(--motes-black);
}
light-image .overlay .icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  height: 80%;
}
light-image .overlay .icon-container .icon {
  font-size: 45px;
}
light-image .overlay .icon-container .plus {
  font-size: 18px;
  padding: 0 7px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/light-image/light-image.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;EACA,sBAAA;EACA,UAAA;AADR;AAII;EACI,UAAA;AAFR;AAKI;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AAHR;AAMI;EACI,gBAAA;EACA,UAAA;EACA,wBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AAJR;AAMQ;EACI,qDAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAJZ;AAQI;EACI,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,uBAAA;AANR;AASI;EACI,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAPR;AAUI;EACI,UAAA;EACA,sCAAA;EACA,6BAAA;AARR;AAWI;EACI;IACI,UAAA;EATV;EAWM;IACI,UAAA;EATV;AACF;AAYI;EACI,6CAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,iBAAA;AAVR;AAYQ;EACI,UAAA;EACA,eAAA;EACA,gBAAA;AAVZ;AAaQ;EACI,mBAAA;EACA,cAAA;EACA,WAAA;AAXZ;AAeI;EACI,oCAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,+BAAA;AAbR;AAeQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;AAbZ;AAgBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AAdZ;AAgBY;EACI,eAAA;AAdhB;AAiBY;EACI,eAAA;EACA,cAAA;AAfhB","sourcesContent":["light-image {\n\n    .image-container {\n        position: relative;\n        width: 100%;\n        overflow: hidden;\n        aspect-ratio: 16/9;\n        background: var(--motes-black);\n        box-sizing: border-box;\n        z-index: 0;\n    }\n\n    .image img {\n        opacity: 0;\n    }\n\n    .image img, .thumb {\n        position: absolute;\n        opacity: 1;\n        top: 0;\n        left: 0;\n        width: 100%;\n        transform: scale(1.3);\n        box-sizing: border-box;\n    }\n\n    .thumb {\n        overflow: hidden;\n        z-index: 3;\n        width: calc(100% + 20px);\n        height: calc(100% + 20px);\n        margin-top: -10px;\n        margin-left: -10px;\n        \n        img {\n            box-shadow: inset 0 0 2000px rgba(255, 255, 255, .5);\n            filter: blur(10px);\n            width: 100%;\n            height: 100%;\n        }\n    }\n\n    .thumb-hidden {\n        will-change: auto;\n        transform: scale(1.6);\n        opacity: 0;\n        transition: 1s;\n        transition-delay: 100ms;\n    }\n\n    .image-shown img {\n        opacity: 1;\n        transform: scale(1);\n        transition: 0.7s ease-out;\n        transition-delay: 100ms;\n    }\n\n    .show-delayed {\n        opacity: 0;\n        animation: delayedFadeIn 2s ease-in 2s;\n        animation-fill-mode: forwards;\n    }\n\n    @keyframes delayedFadeIn {\n        0% {\n            opacity: 0;\n        }\n        100% {\n            opacity: 1;\n        }\n    }\n\n    .placeholder {\n        background: var(--upload-background-gradient);\n        height: 100%;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        opacity: 0;\n        filter: blur(6px);\n\n        &.show {\n            opacity: 1;\n            filter: blur(0);\n            transition: 0.3s;\n        }\n\n        img {\n            object-fit: contain;\n            width: initial;\n            height: 50%;\n        }\n    }\n\n    .overlay {\n        background-color: rgba(0, 0, 0, 0.6);\n        position: absolute;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        color: var(--motes-white);\n        padding: var(--motes-padding);\n        box-sizing: border-box;\n        font-family: var(--header-font);\n\n        .index {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            position: absolute;\n            border: 2px solid var(--motes-white);\n            border-radius: 100%;\n            width: 43px;\n            height: 43px;\n            font-size: 20px;\n            bottom: 10px;\n            background-color: var(--motes-black);\n        }\n\n        .icon-container {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-wrap: wrap;\n            height: 80%;\n            \n            .icon {\n                font-size: 45px;\n            }\n    \n            .plus {\n                font-size: 18px;\n                padding: 0 7px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
